var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCaretDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "7px",
    viewBox: "0 0 11 7",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "98A04480-BEA2-4A85-8732-DC52D9D6B937") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "COD/POD-receipt-(Download-as-Zip)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Zip-1",
    transform: "translate(-956.000000, -523.000000)",
    fill: "#3FAE29",
    fillRule: "nonzero",
    stroke: "#3FAE29",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14-Copy-2",
    transform: "translate(871.000000, 513.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.8954229,13.2530574 L88.609586,9.09721188 C88.4677014,8.96433846 88.2416067,8.9681534 88.1045771,9.10573461 C87.9708959,9.23994732 87.9708959,9.45271119 88.1045771,9.58690361 L92.1379096,13.4979033 L88.1045771,17.408903 C87.965141,17.5441303 87.965141,17.7633674 88.1045771,17.8985947 C88.2440552,18.0338018 88.4701289,18.0338018 88.609586,17.8985947 L92.8954229,13.7427492 C93.034859,13.6075016 93.034859,13.3882848 92.8954229,13.2530574 Z",
    id: "Path",
    transform: "translate(90.500000, 13.500000) rotate(-270.000000) translate(-90.500000, -13.500000) "
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDown);
export default __webpack_public_path__ + "static/media/caret_down.e7d1e60a973502b92442ec1a844756b1.svg";
export { ForwardRef as ReactComponent };